import { render, staticRenderFns } from "./UploadedFileDetails.vue?vue&type=template&id=2569035e&scoped=true&"
import script from "./UploadedFileDetails.vue?vue&type=script&lang=js&"
export * from "./UploadedFileDetails.vue?vue&type=script&lang=js&"
import style0 from "./UploadedFileDetails.vue?vue&type=style&index=0&id=2569035e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2569035e",
  null
  
)

export default component.exports